import * as yup from 'yup';

export const PayrollImportValidationSchema = yup.object().shape({
    includeSalaries: yup.number().typeError('Please select what data you would like to import').required('Please select what data you would like to import'),
    eeScorecards: yup
        .array()
        .test(
            'eeOrBeeRequired',
            'Please select at least one EE or BEE scorecard',
            function (item) {
                return ((this.parent.eeScorecards !== undefined && this.parent.eeScorecards.length > 0) || (this.parent.beeScorecards !== undefined && this.parent.beeScorecards.length > 0))
            }
        ),
    beeScorecards: yup
        .array()
        .test(
            'beeOrEeRequired',
            'Please select at least one BEE or EE scorecard',
            function (item) {
                return ((this.parent.eeScorecards !== undefined && this.parent.eeScorecards.length > 0) || (this.parent.beeScorecards !== undefined && this.parent.beeScorecards.length > 0))
            }
        )
});


